import { format } from "date-fns";
import { useEffect, useState } from "react";
import {
  Box,
  CardHeader,
  Dialog,
  Step,
  StepLabel,
  Stepper,
} from "../../../../components";
import {
  NfSaidaService,
  OperacaoFiscalService,
  OrigemMercadoriaService,
  PessoaService,
  UnidadeComercialService,
  history,
  notification,
} from "../../../../services";
import { formatDate, formatPrice, responseErros } from "../../../../utils";
import { NfSaida, NfSaidaItem } from "../../entities";
import NotaDebitoCreditoStepperContent from "./nota-debito-credito-stepper-content.component";

const NotaDebitoCreditoDialog = ({
  open,
  setOpen,
  setLoading,
  filtrosDialog,
  setFiltrosDialog,
  buscarNfSaida,
  listaPessoas,
  documentoSelectionModel,
  setDocumentoSelectionModel,
  listaOperacoesFiscaisIniciais,
}) => {
  const nfSaidaService = new NfSaidaService();
  const operacaoFiscalService = new OperacaoFiscalService();
  const unidadeComercialService = new UnidadeComercialService();
  const origemMercadoriaService = new OrigemMercadoriaService();
  const pessoaService = new PessoaService();
  const [vendedorList, setVendedorList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [listaNfSaida, setListaNfSaida] = useState([]);
  const [countNfSaida, setCountNfSaida] = useState(0);
  const [documentoSelecionado, setDocumentoSelecionado] = useState({});
  const [itemSelectionModel, setItemSelectionModel] = useState([]);
  const [itensSelecionados, setItensSelecionados] = useState([]);
  const [listaOperacoesFiscais, setListaOperacoesFiscais] = useState([]);
  const [unidadeList, setUnidadeList] = useState([]);
  const [origensMercadoriaList, setOrigensMercadoriaList] = useState([]);
  const [operacaoFiscal, setOperacaoFiscal] = useState(null);
  const steps = [
    "Selecionar Operação Fiscal",
    "Selecionar Nota de Saída",
    "Selecionar Itens",
  ];
  const colunas = [
    {
      field: "serieDocumento",
      headerName: "Série",
      flex: 90,
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Documento",
      flex: 140,
    },
    {
      field: "dataEmissao",
      headerName: "Data de Emissão",
      flex: 150,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "operacaoFiscalId",
      headerName: "Operação Fiscal",
      flex: 190,
      valueGetter: (params) => {
        const opFiscal = listaOperacoesFiscaisIniciais.find(
          (item) => item.id == params.value,
        );
        if (!opFiscal) return params.value;
        return opFiscal.descricao;
      },
    },
    {
      field: "clienteId",
      headerName: "Cliente",
      flex: 200,
      valueGetter: (params) => {
        const cliente = listaPessoas.find((item) => item.id == params.value);
        if (!cliente) return params.value;
        return cliente.nomeRazaoSocial;
      },
    },
    {
      field: "vendedorId",
      headerName: "Vendedor",
      flex: 200,
      valueGetter: (params) => {
        const vendedor = vendedorList.find((item) => item.id == params.value);
        if (!vendedor) return params.value;
        return vendedor.nomeRazaoSocial;
      },
    },
    {
      field: "nfSaidaItens",
      headerName: "Total da Venda",
      flex: 240,
      valueGetter: (params) => {
        const totalNfSaida =
          params.value
            .map((item) => item.subtotal)
            .reduce((acumulador, total) => acumulador + total, 0) +
          params.row.frete +
          params.row.acrescimo -
          params.row.desconto +
          params.row.despesas;
        return formatPrice(totalNfSaida);
      },
    },
  ];

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 4,
      vendedor: true,
      ativado: true,
      attributes: ["id", "nomeRazaoSocial"],
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarOperacoesFiscais = () => {
    const filtro = {
      ativado: true,
      nonPaginated: true,
      tipoOperacao: "SAIDA",
      finalidade: ["NOTA_DEBITO", "NOTA_CREDITO"],
      restritiva: true,
      porIntervalo: [],
    };
    operacaoFiscalService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaOperacoesFiscais(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  useEffect(() => {
    if (open) {
      buscarOperacoesFiscais();
      buscarOrigensMercadoria();
      buscarUnidadesComerciais();
      buscarNfSaidaAvancado({});
      buscarVendedores();
    }
  }, [open]);

  const buscarNfSaidaAvancado = async (filtros) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filtros,
      modeloDocumento: "55",
      status: "ENVIADA",
    };
    if (
      filtrosAvancadosTemp.dataEmissaoStart &&
      filtrosAvancadosTemp.dataEmissaoEnd
    ) {
      porIntervalo.push({
        coluna: "dataEmissao",
        de: filtrosAvancadosTemp.dataEmissaoStart,
        ate: filtrosAvancadosTemp.dataEmissaoEnd,
      });
    }
    delete filtrosAvancadosTemp.dataEmissaoStart;
    delete filtrosAvancadosTemp.dataEmissaoEnd;
    setLoading(true);
    const result = await nfSaidaService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    setLoading(false);
    if (!result.isAxiosError) {
      setCountNfSaida(result.data.count);
      setListaNfSaida(result.data.rows);
    } else {
      responseErros(result);
    }
    setFiltrosDialog({});
  };

  const buscarOrigensMercadoria = async () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriaList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarUnidadesComerciais = async () => {
    const filtros = {
      nonPaginated: true,
    };
    unidadeComercialService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setUnidadeList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const handleInputChange = (e) => {
    e.persist();
    setFiltrosDialog((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDateChange = (date, fieldName) => {
    setFiltrosDialog((prevState) => ({
      ...prevState,
      [fieldName]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    }));
  };

  const handleImportarMercadorias = async () => {
    if (!operacaoFiscal) {
      notification.alertaGenericos("Operação fiscal deve ser informada");
      return;
    }
    setLoading(true);
    window.nfSaidaEntity = await createNfSaida(
      documentoSelecionado,
      itensSelecionados,
      operacaoFiscal,
    );
    setOpen(false);
    resetarDados();
    setLoading(false);
    let cadastroUri = "nota-debito";
    if (operacaoFiscal.finalidade === "NOTA_CREDITO") {
      cadastroUri = "nota-credito";
    }
    history.push(`/faturamento/nf-saida/${cadastroUri}`);
  };

  const createNfSaida = async (documento, itens, operacaoFiscal) => {
    if (
      operacaoFiscal.modeloDocumento == "055" ||
      operacaoFiscal.modeloDocumento == "065"
    ) {
      return notification.alertaGenericos(
        "Operação fiscal sem regra de tributação associada.",
      );
    }
    const nfSaidaItens = itens
      .filter((item) => itemSelectionModel.indexOf(item.id) > -1)
      .map((item, index) => {
        const nfSaidaItem = new NfSaidaItem(
          item,
          index,
          operacaoFiscal,
          origensMercadoriaList,
          unidadeList,
        );
        return {
          ...nfSaidaItem,
          produto: item.produto,
          valor: parseFloat(item.valor.toFixed(2)),
          subtotal: parseFloat(item.valor.toFixed(2)) * item.quantidade,
        };
      });
    const dadosNfSaida = {
      ...documento,
      dataEmissao: formatDate.toSend(new Date()),
      modalidadeFrete: "mfSemFrete",
      freteCompoeNota: false,
      id: undefined,
      numeroDocumento: undefined,
      operacaoFiscalId: operacaoFiscal.id,
      operacaoFiscal,
      finalidadeNfe: operacaoFiscal?.finalidade === "NOTA_CREDITO" ? "5" : "6",
      tipoFinalidadeFiscal: operacaoFiscal?.tipoFinalidadeFiscal,
      serieDocumento: operacaoFiscal?.serieDocumento,
      modeloDocumento: operacaoFiscal?.modeloDocumento,
      nfSaidaItens,
      totalPagamentos: 0,
      nfSaidaPagamentos: [],
    };
    return new NfSaida(dadosNfSaida, true);
  };

  const resetarDados = () => {
    setOperacaoFiscal(null);
    setDocumentoSelectionModel([]);
    setDocumentoSelecionado([]);
    setActiveStep(0);
  };

  const handleCancelarImportacao = () => {
    resetarDados();
    setOpen(false);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      if (props.filtros?.status) {
        delete props.filtros.status;
      }
      buscarNfSaida(props.filtros);
    } else {
      buscarNfSaidaAvancado(props.filtros);
    }
  };

  return (
    <Dialog fullWidth maxWidth="xl" open={open}>
      <Box sx={{ m: 2 }}>
        <CardHeader title="Nota de Débito/Crédito" />
      </Box>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <NotaDebitoCreditoStepperContent
        sendServer={sendServerDatagrid}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleImportarMercadorias={handleImportarMercadorias}
        handleCancelarImportacao={handleCancelarImportacao}
        handleInputChange={handleInputChange}
        handleDateChange={handleDateChange}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        setOperacaoFiscal={setOperacaoFiscal}
        operacaoFiscal={operacaoFiscal}
        colunas={colunas}
        listaNfSaida={listaNfSaida}
        countNfSaida={countNfSaida}
        documentoSelecionado={documentoSelecionado}
        setDocumentoSelecionado={setDocumentoSelecionado}
        setItensSelecionados={setItensSelecionados}
        buscarNfSaidaAvancado={buscarNfSaidaAvancado}
        listaClientes={listaPessoas}
        listaOperacoesFiscais={listaOperacoesFiscais}
        itemSelectionModel={itemSelectionModel}
        setItemSelectionModel={setItemSelectionModel}
        documentoSelectionModel={documentoSelectionModel}
        setDocumentoSelectionModel={setDocumentoSelectionModel}
      />
    </Dialog>
  );
};

export default NotaDebitoCreditoDialog;
